import React from "react";
import { Tabs, Stack, Text, Title, Box } from "@mantine/core";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { ADMIN_TAB_ROOT_STYLE, ADMIN_TAB_CONTENT_STYLE } from "../adminTabLayout";

const IdeaAdministration: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const activeTab = "inbox";

    const handleTabChange = (value: string | null) => {
        if (!value || value === activeTab) {
            return;
        }
        navigate(`/administration/ideas/inbox`);
    };

    return (
        <Stack gap="lg" style={ADMIN_TAB_ROOT_STYLE}>
            <Stack gap={4}>
                <Title order={2}>Ideas</Title>
                <Text size="sm" c="dimmed">
                    Browse and export product ideas submitted by Arthrex employees through ARTI.
                </Text>
            </Stack>

            <Tabs value={activeTab} onChange={handleTabChange} variant="pills" radius="md">
                <Tabs.List>
                    <Tabs.Tab value="inbox">Inbox</Tabs.Tab>
                </Tabs.List>
            </Tabs>

            <Box pt="md" style={ADMIN_TAB_CONTENT_STYLE}>
                <Outlet />
            </Box>
        </Stack>
    );
};

export default IdeaAdministration;
